import Gallery from './Gallery';
import query from './GalleryQuery.graphql';

Gallery.query = query;

export default Gallery;
